/// <reference path="../../../AppKitchen/typings/AppKitchen.UI.d.ts"/>
/// <reference path="../../typings/EEX.McEc.Api.d.ts"/>

module EEX.McEc.Data.Provider {

    export class AddCsrProvider extends AppKitchen.Data.Provider.ProviderBase {

        public add(request: Domain.AddCsrRequest): JQueryPromise<Domain.CertificateModel> {
            return this.do("AddCsr", request);
        }
    }
}